// COPYRIGHT © 2019 Esri
//
// All rights reserved under the copyright laws of the United States
// and applicable international laws, treaties, and conventions.
//
// This material is licensed for use under the Esri Master License
// Agreement (MLA), and is bound by the terms of that agreement.
// You may redistribute and use this code without modification,
// provided you adhere to the terms of the MLA and include this
// copyright notice.
//
// See use restrictions at http://www.esri.com/legal/pdfs/mla_e204_e300/english
//
// For additional information, contact:
// Environmental Systems Research Institute, Inc.
// Attn: Contracts and Legal Services Department
// 380 New York Street
// Redlands, California, USA 92373
// USA
//
// email: contracts@esri.com
//
// See http://js.arcgis.com/next/esri/copyright.txt for details.

define({lblItem:"item",title:"Aanmelden",info:"Meld u aan om toegang te krijgen tot het item op {server} {resource}",oAuthInfo:"Meld u aan bij {server}.",lblUser:"Gebruikersnaam:",lblPwd:"Wachtwoord:",lblOk:"OK",lblSigning:"Aanmelden...",lblCancel:"Annuleren",errorMsg:"Ongeldige gebruikersnaam/ongeldig wachtwoord. Probeer het opnieuw.",invalidUser:"De ingevoerde gebruikersnaam of het ingevoerde wachtwoord is ongeldig.",forbidden:"De gebruikersnaam en het wachtwoord zijn geldig, maar u hebt geen toegang tot deze resource.",noAuthService:"Kan geen toegang krijgen tot de verificatieservice."});